import { useQuery } from '@tanstack/react-query';

import { brandCategoryPageMetadataQueryOptions } from './queries';

export function useBrandCategoryPageMetadata(
  brandSlug: string,
  categoryPathname: string
) {
  return useQuery(
    brandCategoryPageMetadataQueryOptions(`/${brandSlug}/c/${categoryPathname}`)
  );
}
